import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { defaultAxiosInstance } from "services/client"

export interface SaveScheduleMessageResponseData extends AxiosResponse {
  data: string
  message: string
}
export interface SaveScheduleMessageResponse extends AxiosResponse {
  data: SaveScheduleMessageResponseData
}

export type PropertyId = {
  propertyId: string
}

export interface FetchScheduleMessageType {
  pmcId: string
  name: string
  message: string
  scheduledType: string
  duration: number
  templateId?: number | null
  propertyIds: PropertyId[]
}
export interface SaveScheduleMessageRequest
  extends Partial<AxiosRequestConfig> {
  data: FetchScheduleMessageType
}

const defaultSaveScheduleMessageUrl = `${
  process.env.REACT_APP_BASE_API_URL || ""
}/sendbird/save-schedule-template`

export function saveScheduleMessageApi(
  {
    data,
    method = "post",
    url = defaultSaveScheduleMessageUrl,
    ...config
  }: SaveScheduleMessageRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<SaveScheduleMessageResponse> {
  return axiosInstance({
    method,
    url,
    data,
    ...config,
  }) as Promise<SaveScheduleMessageResponse>
}
